<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { useVModel } from '@vueuse/core'
import { cn } from '@/lib/utils'

const props = defineProps<{
	defaultValue?: string | number
	modelValue?: string | number
	class?: HTMLAttributes['class']
	lazy?: boolean
}>()

const emits = defineEmits<{
	(e: 'update:modelValue', payload: string | number): void
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
	passive: true,
	defaultValue: props.defaultValue,
})
</script>

<template>
	<input
		v-if="lazy"
		v-model.lazy="modelValue"
		enterkeyhint="search"
		:class="
			cn(
				'h-10 bg-background px-3 py-2 ring-offset-background placeholder:text-muted-foreground flex w-full rounded-md text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:cursor-not-allowed disabled:opacity-50',
				'border border-n-100 focus:border-2 focus:border-n-950',
				'outline-none',
				props.class ?? '',
			)
		"
	/>
	<input
		v-else
		v-model="modelValue"
		enterkeyhint="search"
		:class="
			cn(
				'bg-background ring-offset-background placeholder:text-muted-foreground flex h-[44px] w-full rounded-md text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:cursor-not-allowed disabled:opacity-50',
				'border border-n-100 focus:border-2 focus:border-n-950',
				'outline-none',
				props.class ?? '',
			)
		"
	/>
</template>
